import * as T from './types'

export default {
    [T.SET_BREADCRUMB_ROUTES](state, payload) {
        state.breadcrumbRoutes = payload
    },
    [T.SET_APILIST](state, { data, type }) {
        if (type === 'list') {
            state.listApis = data
        } else {
            state.formApis = data
        }
    },
    [T.SET_API_DATA](state, { data, type }) {
        if (type === 'list') {
            state.listApiData = data
        } else {
            state.formApiData = data
        }
    },

    [T.SET_LISTVIEW](state, payload) {
        state.listview = payload
    },
    [T.SET_LISTVIEW_DETAIL](state, payload) {
        state.listviewDetail = payload
    },

    [T.SET_FORMVIEW](state, payload) {
        state.formview = payload
    },
    [T.SET_FORMVIEW_DETAIL](state, payload) {
        state.formviewDetail = payload
    },

    [T.SET_ENGINE_LIST](state, payload) {
        state.engineList = payload
    },
}
